import FormikInput from 'components/formikFields/input';
import FormikInputGroup from 'components/formikFields/inputGroup/idnex';
import {Form, Formik} from 'formik';
import Header from 'modules/header/farm/main';
import {useFarm} from 'context/farmContext';
import {initialValues} from './utilities/initialValues';
import FormikRadioButtons from 'components/formikFields/radioButtons';
import {typeOptions} from './utilities/radioOptions';
import InputGroups from './inputGroups';
import {formDataCreator} from '../utilities/formDataCreatot';
import useSetInputGroups from './hooks/useSetInputgroups';
import {schema} from './utilities/validationSchema';
import {durationUnits} from 'utilities/helper/durationUnitsOption';
import Num2persian from 'utilities/helper/convertNumToPersian';
import useSetAnswers from '../../form/owner/simple/hooks/useSetAnswers';
import {useEffect, useState} from 'react';
import useGetGradeQuestions from 'utilities/hooks/grade/get/useGetGradeQuestions';
import CustomBottomSheet from 'components/bottomSheet';
import Grade from 'components/forms/simple/grade';
import useSetGradeAnswers from '../../form/hooks/useSetGradeAnswers';
import {qualityConvertor} from 'utilities/helper/quality';
import Quality from 'assets/images/grade/quality.svg';
import classNames from 'classnames';
import DotsLoading from 'components/loadings/dotsLoading';
import usePostEditAd from '../hooks/usePostEditAd';
import {useParams} from 'react-router-dom';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
import usePostEditDetail from '../hooks/usePostEditDetail';

const PrePaymentForm = () => {
  const {farm} = useFarm();
  const {guid} = useParams();
  const {productDetail} = useGetPostDetail(guid || '');

  const {handleSelectInputGroup, selectedInputGroups, inputGroups} =
    useSetInputGroups();
  const {isLoading, mutate} = usePostEditAd();
  const {postEditDetail} = usePostEditDetail(guid || '');

  const {answers, handleAnswers} = useSetAnswers();
  const [isOpenGrade, setIsOpenGrade] = useState<boolean>(false);
  const [isOpenGradeAnswer, setIsOpenGradeAnswer] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [questions, setQuestions] = useState<IGetGradeQuestions[]>([]);
  const [grade, setGrade] = useState<number>(0);
  const [isOpenGradeQuestions, setIsOpenGradeQuestions] =
    useState<boolean>(false);
  const {gradeQuestions} = useGetGradeQuestions(
    setQuestions,
    setIsOpenGradeQuestions,
  );
  const {gradeMutate} = useSetGradeAnswers(
    setIsOpenGrade,
    setIsOpenGradeAnswer,
    setGrade,
  );
  const handleGradeAnswer = () => {
    setIsOpenGrade(false);
    setIsOpenGradeAnswer(true);
    const answersGuid: string[] = [];
    if (answers.length > 0) {
      answers.map(item => answersGuid.push(item.guid));
    }
    gradeMutate({
      subproduct: farm && farm.subProduct ? farm.subProduct : '',
      answers: answersGuid.toString(),
    });
  };
  useEffect(() => {
    if (isChecked && farm) {
      gradeQuestions(farm.subProduct ? farm.subProduct : '');
    }
  }, [isChecked, gradeQuestions, farm]);
  return (
    <>
      <Header title=" ثبت آگهی سلف" />
      <Formik
        initialValues={initialValues(farm, productDetail, postEditDetail  )}
        validationSchema={schema}
        onSubmit={values => {
          const payload = new FormData();
          formDataCreator(payload, farm, guid);
          payload.append('duration', values.duration);
          payload.append('duration_unit', values.duration_unit);
          values.price && payload.append('price', values?.price);
          payload.append('financial_type', values.financial_type);
          values.financial_type === 'credit' &&
            payload.append('input_groups_code', selectedInputGroups);
          if (answers.length > 0 && isChecked) {
            const answersGuid: string[] = [];
            answers.map(item => answersGuid.push(item.guid));
            payload.append('answers', answersGuid.toString());
          }
          !isLoading && mutate(payload);
        }}
      >
        {({values}) => (
          <Form className="mt-8 px-3">
            <div className="mt-6">
              <FormikInput
                label="مساحت"
                name="area"
                type="number"
                secondaryTitle="هکتار"
                disabled
              />
            </div>
            <div className="mt-6">
              <FormikInputGroup
                name="duration"
                label="مدت زمان آگهی*"
                Options={durationUnits}
                optionName="duration_unit"
              />
            </div>
            <div className="mt-6">
              <FormikInput
                label="مقدار نیاز مالی"
                name="price"
                type="number"
                secondaryTitle="تومان"
              />
              {values.price && (
                <div className="flex my-2 text-sm">
                  <span className=" ml-1 icon-information text-blue-1 mt-1 "></span>
                  <small className=" text-blue-1">
                    {Num2persian(values.price?.toString())} تومان
                  </small>
                </div>
              )}
            </div>
            <div className="mt-6">
              <FormikRadioButtons
                name="financial_type"
                title="نوع تامین مالی:"
                options={typeOptions}
              />
              {values.financial_type === 'credit' && (
                <>
                  <InputGroups
                    handleSelectInputGroup={handleSelectInputGroup}
                    inputGroups={inputGroups}
                  />
                </>
              )}
            </div>

            <div className=" flex justify-between">
              <div className="mt-6 flex">
                <label>
                  <input
                    type="checkbox"
                    className="mx-2"
                    checked={isChecked}
                    onChange={() => {
                      if (!isChecked) {
                        setIsChecked(!isChecked);
                        setIsOpenGrade(!isOpenGrade);
                      } else {
                        setIsChecked(false);
                      }
                    }}
                  />
                  تعیین سطح کیفیت محصول
                </label>
              </div>
              {isChecked && grade > 0 && (
                <p
                  className={classNames(
                    ' mt-6 py-0.5 px-2 rounded-full',
                    Number(grade) === 1 && ' bg-warning-1 text-warning-2',
                    Number(grade) === 2 && ' bg-natural-3 text-natural-4',
                    Number(grade) === 3 && ' bg-error-1 text-warning-2',
                    Number(grade) > 3 && ' bg-Cyan-chat-6 text-green-grade',
                  )}
                >
                  درجه {grade}
                </p>
              )}
            </div>

            <div className="mt-8">
              <button
                type="submit"
                className=" w-full text-white bg-primary py-4 rounded-lg mb-6"
                disabled={isLoading}
              >
                {isLoading ? (
                  <DotsLoading extraStyleCircle="!bg-white" />
                ) : (
                  'ثبت آگهی'
                )}{' '}
              </button>
            </div>
          </Form>
        )}
      </Formik>
      {isOpenGradeQuestions && (
        <CustomBottomSheet
          isOpen={isOpenGrade}
          onDismiss={() => {
            setIsChecked(false);
            setIsOpenGrade(false);
          }}
          questions={true}
        >
          <>
            <div className=" flex justify-between mb-3 text-sm">
              <p className=" text-gray-6">تعیین سطح کیفیت محصول</p>
              <span
                className="icon-close text-gray-6 "
                onClick={() => {
                  setIsOpenGrade(false);
                  setIsChecked(false);
                }}
              ></span>
            </div>
            <p className=" text-gray-6 text-justify mb-3 text-sm">
              با پاسخ به چند سوال، درجه کیفیت محصول شما ارزیابی شده و در آگهی
              نمایش داده می‌شود.
            </p>
            <Grade
              questions={questions}
              handleAnswers={handleAnswers}
              setIsOpenGrade={setIsOpenGrade}
              handleGradeAnswer={handleGradeAnswer}
              answers={answers}
            />
          </>
        </CustomBottomSheet>
      )}

      {isOpenGradeAnswer && (
        <>
          <CustomBottomSheet
            isOpen={isOpenGradeAnswer}
            onDismiss={() => setIsOpenGradeAnswer(false)}
          >
            <div>
              <img src={Quality} alt="quality" className="block mx-auto my-3" />
              <p>
                سطح کیفیت محصول شما :{' '}
                <span
                  className={classNames(
                    ' mt-6 py-0.5 px-2 rounded-full',
                    Number(grade) === 1 && ' bg-warning-1 text-warning-2',
                    Number(grade) === 2 && ' bg-natural-3 text-natural-4',
                    Number(grade) === 3 && ' bg-error-1 text-warning-2',
                    Number(grade) > 3 && ' bg-Cyan-chat-6 text-green-grade',
                  )}
                >
                  درجه {qualityConvertor[grade]}
                </span>{' '}
                می باشد.
              </p>
              <button
                className=" text-white bg-green-1 py-4 text-center w-full rounded-md my-3"
                onClick={() => setIsOpenGradeAnswer(false)}
              >
                متوجه شدم
              </button>
            </div>
          </CustomBottomSheet>
        </>
      )}
    </>
  );
};

export default PrePaymentForm;
